import React from 'react';
import { DirectionsRenderer } from '@react-google-maps/api';
import { useMapPolyline } from '@hero/web-hooks';

/**
 * RoutePolyline - Renders route lines (actual routes or straight lines)
 * Uses direct Google Maps API for straight lines to avoid React Strict Mode duplication issues
 */
export function RoutePolyline() {
  // Use the hook with a visibility function based on context
  const { ctx } = useMapPolyline({
    isVisible: ctx => ctx.routeLineType === 'straight' && ctx.editingIndex === null,
    strokeColor: '#3532A7',
    strokeWeight: 4,
    strokeOpacity: 0.8,
    showArrows: true,
  });

  // Don't render anything if we don't have enough locations
  if (ctx.locations.length < 2) {
    return null;
  }

  // For actual_route type, use DirectionsRenderer (keep existing approach)
  if (
    ctx.routeLineType === 'actual_route' &&
    ctx.directions.length > 0 &&
    ctx.editingIndex === null
  ) {
    const arrowPath =
      typeof google !== 'undefined' && google.maps && google.maps.SymbolPath
        ? google.maps.SymbolPath.FORWARD_CLOSED_ARROW
        : 'M 0,-1 0,1';

    return (
      <>
        {ctx.directions.map((direction, index) => (
          <DirectionsRenderer
            key={`direction-${ctx.directionsKey}-${index}`}
            directions={direction}
            options={{
              suppressMarkers: true,
              polylineOptions: {
                strokeColor: '#3532A7',
                strokeWeight: 4,
                strokeOpacity: 0.8,
                icons: [
                  {
                    icon: {
                      path: arrowPath,
                      scale: 5.5,
                      strokeColor: '#FFFFFF',
                      strokeWeight: 2.5,
                      fillColor: '#3532A7',
                      fillOpacity: 1,
                    },
                    offset: '15%',
                    repeat: '200px',
                  },
                ],
              },
            }}
          />
        ))}
      </>
    );
  }

  // Straight lines are managed by useEffect, no JSX needed
  return null;
}
